import { useCallback, useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import { useIsModalOpen } from '~/hooks/useIsModalOpen';

const useCropModeShortcuts = ({ toggleMode }: { toggleMode?: () => void }) => {
    const isModalOpen = useIsModalOpen();

    const handleKeyDown = useCallback(
        (e: KeyboardEvent): void => {
            if (isInteractiveElement(e) || isCtrlKey(e) || e.shiftKey || isModalOpen) {
                return;
            }

            switch (e.code) {
                case 'KeyC': {
                    if (toggleMode) {
                        toggleMode();
                    }

                    break;
                }

                default:
                    break;
            }
        },
        [toggleMode, isModalOpen],
    );

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
};

export default useCropModeShortcuts;
